import { useWorksheetChecklist } from '../../../queries/use-worksheet-checklist';
import { Worksheet } from '../../../types/worksheet';
import { WorksheetChecklistItemStatusEnum } from '../../../types/worksheet-checklist-item';
import Checklist from '../../worksheet-v2/checklist/Checklist';
import PreviewSection from '../PreviewSection';

type ChecklistPreviewProps = {
    worksheet: Worksheet;
};

function ChecklistPreview({ worksheet }: ChecklistPreviewProps): JSX.Element {
    const count = worksheet.checklist.length;
    const done = worksheet.checklist.filter((item) => item.status !== WorksheetChecklistItemStatusEnum.UNCHECKED).length;

    const checklistQuery = useWorksheetChecklist(worksheet.id);

    if (checklistQuery.isLoading || !checklistQuery.isSuccess) {
        return <></>;
    }

    return (
        <PreviewSection title={`Checklist ${count === 0 ? '(0)' : `(${done}/${count})`}`}>
            <div className={`mt-2 ${count === 0 ? 'hidden' : ''}`}>
                <Checklist worksheet={worksheet} compactView />
            </div>
        </PreviewSection>
    );
}

export default ChecklistPreview;
